/* eslint-disable react/no-unstable-nested-components */
import { createColumnHelper, getCoreRowModel, getPaginationRowModel, useReactTable } from "@tanstack/react-table";
import DividendsTable from "components/company/v3/contents/events/dividends/DividendsTable";
import type { TDividendsPaidByYear } from "components/company/v3/contents/events/dividends/types";
import classNames from "components/ui/classNames";
import numeral from "numeral";
import { FormattedMessage } from "react-intl";

interface DividendsPaidByYearProps {
  dividendsPaid: TDividendsPaidByYear[];
  currency: "BRL" | "USD";
  isRenderPageDefault?: boolean;
}

export default function DividendsPaidByYear({
  dividendsPaid,
  currency,
  isRenderPageDefault = false,
}: DividendsPaidByYearProps) {
  const columnHelper = createColumnHelper<TDividendsPaidByYear>();

  const columns = [
    columnHelper.accessor("year", {
      header: () => <FormattedMessage defaultMessage="Ano" id="wY7G7a" />,
      cell: (info) => (
        <div
          className={classNames(
            "whitespace-nowrap",
            "px-4 py-1.5 text-sm font-normal",
            "text-slate-600 dark:text-slate-300",
          )}
        >
          <span>{info.getValue()}</span>
        </div>
      ),
    }),
    columnHelper.accessor("amountPaid", {
      header: () =>
        currency === "BRL" ? (
          <FormattedMessage defaultMessage="Valor (R$)" id="egpnv2" />
        ) : (
          <FormattedMessage defaultMessage="Valor (U$)" id="ZxcsXk" />
        ),
      cell: (info) => (
        <div
          className={classNames(
            "whitespace-nowrap",
            "px-4 py-1.5 text-sm font-normal",
            "text-slate-600 dark:text-slate-300",
          )}
        >
          <span>{numeral(info.getValue()).format("0.00").replace(".", ",")}</span>
        </div>
      ),
    }),
  ];

  const table = useReactTable({
    data: dividendsPaid,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      pagination: {
        pageSize: isRenderPageDefault ? 10 : 16,
      },
    },
  });

  return <DividendsTable table={table} />;
}
